import React, { useEffect, useRef } from "react";

import { makePost } from "@culturehq/client";
import { Icon } from "@culturehq/components";

import { StoryQuestion, Suggestion } from "chq";

import { useIsMobile } from "app/hooks";
import { Trans } from "app/utils";

type PromptEditProps = {
  chatId: string;
  storyQuestionId: StoryQuestion["id"];
  textStory: Suggestion["story"];
  onSuggestionChange: (suggestion: Partial<Suggestion>) => void;
  onLoading: (value: boolean) => void;
};

const PromptEdit: React.FC<PromptEditProps> = ({
  chatId,
  storyQuestionId,
  textStory,
  onSuggestionChange,
  onLoading
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const isMobile = useIsMobile();

  useEffect(() => {
    // Focus the textarea when the component mounts {{ edit_2 }}
    if (textareaRef.current) {
      textareaRef.current.focus();
      textareaRef.current.setSelectionRange(
        textareaRef.current.value.length, textareaRef.current.value.length
      );
    }
  }, []);

  const handleTextChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onSuggestionChange({ story: event.target.value });
  };

  const handleOnClickRefresh = () => {
    onLoading(true);
    makePost("/ai/public/reload_story_suggestion", { chatId, storyQuestionId })
      .then(({ suggestion }: any) => {
        onSuggestionChange({ story: suggestion.story });
        onLoading(false);
      });
  };

  return (
    <div className="MainContainerIntelligence__Edit">
      <div className="MainContainerIntelligence__Title">
        {!isMobile && <h2><Trans>Edit story</Trans></h2>}
        <Icon
          className="refresh-icon"
          icon="refresh"
          onClick={handleOnClickRefresh}
        />
        {isMobile && <h4><Trans>Try again</Trans></h4>}
      </div>
      <div className="TextArea-Container">
        <div className="TextArea-Tip">
          <Icon icon="info-v2-filled" />
          <p>
            <Trans>
              This story below was generated using your responses
              and other context set by your organization. Click in the text box to edit!
            </Trans>
          </p>
        </div>
        <textarea
          ref={textareaRef}
          className="MainContainerIntelligence__Textarea-txt no-scrollbar"
          onChange={handleTextChange}
          placeholder="Edit your story here..."
          value={textStory}
        />
      </div>
    </div>
  );
};

export default PromptEdit;
